module.exports = __webpack_public_path__ + "static/media/Road turn right.1402b0b3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/elements/Road turn right.svg
// module id = 198
// module chunks = 0